import Swup from 'swup'

import SwupBodyClassPlugin from '@swup/body-class-plugin'

export function runSwup({
    EventBus,
    EVENTS,
    ScrollService,
    scrollToElement,
    loadComponents,
    removeComponents,
	scrollHistory,
	setScrollPosition,
	runScriptsInsideElement,
	NajaService,
}) {
    if (!EventBus || !ScrollService || !EVENTS || !scrollToElement || !loadComponents || !removeComponents || !scrollHistory || !setScrollPosition) {
        console.error('Dependencies required to run swup')
        return
    }

    const swup = new Swup({
		linkSelector: [
			'a[href^="' + window.location.origin + '"]:not([data-no-swup]):not([target="_blank"]):not(.ajax):not([download]):not([data-component])',
			'a[href^="/"]:not([data-no-swup]):not([target="_blank"]):not(.ajax):not([download]):not([data-component])',
		].join(', '),
		animationSelector: '.Swup',
		containers: ['#swup', '#modals', '#header-nav', '#header-left'],
		plugins: [new SwupBodyClassPlugin()],
	})

	swup.hooks.on('link:click', (event) => {
		EventBus.emit(EVENTS.SWUP_CLICK_LINK, { event })
        scrollHistory.saveCurrent()
	})

	swup.hooks.on('visit:start', (visit) => {
		const els = [...document.querySelectorAll(visit.containers.join(','))]
		els.forEach((element) => {
			removeComponents(element)
		})
	})

	swup.hooks.on('content:replace', (visit) => {
        if (Nette) {
            Nette.reinit()
        }

		const els = [...document.querySelectorAll(visit.containers.join(','))]
		els.forEach((element) => {
			loadComponents(element)
			NajaService.uiHandler.bindUI(element);

			//poustet angelcam scripty po swupu na kazdy strance
            const angelCam = document.getElementById('angelcam')
            if (angelCam) {
                runScriptsInsideElement(angelCam)
            }
		})

        if (ScrollService) {
            ScrollService.resize()

			const historyState = scrollHistory.getCurrent()
			if (historyState) {
				setScrollPosition(historyState.scroll.x, historyState.scroll.y)
			}
            document.body.style.height = ``
        }
		EventBus.emit(EVENTS.SWUP_CONTENT_REPLACED)

		setTimeout(() => {
			const url = visit?.to?.url
			if (!url) return

			const urlObj = new URL(url, window.location.origin)
			const scrollValue = urlObj.searchParams.get('scroll')

			if (scrollValue) {
				urlObj.searchParams.delete('scroll')
				urlObj.hash = scrollValue
				window.history.replaceState({}, '', urlObj.toString())

				const anchor = document.querySelector(`#${scrollValue}`)

				if (anchor) {
					scrollToElement(anchor, {
						mode: 'force',
					})
				}
			}
		}, 0);
	})

	swup.hooks.on('history:popstate', () => {
		const historyState = scrollHistory.getCurrent()
        if (historyState) {
            document.body.style.height = `${historyState.height}px`
        }
	})

	window.swup = swup
}
